import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { DEFAULT_LOCALE, messages } from '@/locale';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  messages
});
export default i18n;